import { render, staticRenderFns } from "./CnyBanner.vue?vue&type=template&id=5f291cc0&"
import script from "./CnyBanner.vue?vue&type=script&lang=ts&"
export * from "./CnyBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CnyBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports